module.exports = __webpack_public_path__ + "static/p07_cencerro-012a2ae76b573e8e87da02ce275982b8.png";